import { storageModel } from "../libs/storage-manager";

export const themes = {
  Light: {
    "--background-color": "#ffffff",
    "--text-color": "#000000",
    "--item-background-color": "#ffffff",
    "--border-color": "#F2F2F2",
    "--card-background": "#ffffff",
  },
  Dark: {
    "--background-color": "#121212",
    "--text-color": "#f5f5f5",
    "--item-background-color": "#1C1C1E",
    "--border-color": "#4D4D4D",
    "--card-background": "rgba(30,38,58,0.96)",
  },
  extend: {
    colors: {
      "birthday-primary": "#FF6B6B",
      "birthday-secondary": "#FFD93D",
      "birthday-accent": "#6C5CE7",
      "birthday-bg": "#FFF0F0",
      "birthday-text": "#2D3436",
    },
  },
};

export const isDarkMode =
  typeof localStorage !== "undefined" ? storageModel.isDarkMode === "Y" : false;

if (typeof document !== "undefined") {
  const activeTheme = isDarkMode ? themes.Dark : themes.Light;
  Object.keys(activeTheme).forEach((property: string) => {
    document.documentElement.style.setProperty(
      property,
      activeTheme[property as keyof typeof activeTheme],
    );
  });
}
